import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export var SortingOption;
(function (SortingOption) {
    SortingOption["RELEVANCE"] = "relevance";
    SortingOption["MOST_USED"] = "most_used";
    SortingOption["TRENDING"] = "trending";
    SortingOption["ALPHABETICAL_ASC"] = "alphabetical_asc";
    SortingOption["ALPHABETICAL_DESC"] = "alphabetical_desc";
})(SortingOption || (SortingOption = {}));
export const useRouteSortingStore = create()(persist((set) => ({
    sortingOption: SortingOption.RELEVANCE,
    setSortingOption: (val) => set({ sortingOption: val }),
}), {
    name: 'ls-route-sorting',
    storage: createJSONStorage(() => localStorage),
}));
